export const dashboardTestId = 'dashboard-page-test-id';
